var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCouponIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 5,
    fill: "none",
    viewBox: "0 0 7 5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.1,
    d: "M2.148 1.602a.37.37 0 1 0 0 .74.37.37 0 0 0 0-.74zM4.26 2.658a.37.37 0 1 0 0 .74.37.37 0 0 0 0-.74z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.1,
    d: "M.652 4.982H5.99c.35 0 .634-.285.634-.635V3.322c0-.124-.1-.224-.224-.224a.598.598 0 0 1 0-1.195c.124 0 .224-.1.224-.223V.652A.635.635 0 0 0 5.99.018H.652a.635.635 0 0 0-.634.634V1.68c0 .123.1.223.224.223a.598.598 0 0 1 0 1.195c-.124 0-.224.1-.224.224v1.026c0 .35.285.635.634.635zm-.187-.635V3.52c.47-.102.821-.52.821-1.02s-.352-.918-.82-1.02V.651C.465.55.548.465.651.465H5.99c.103 0 .187.084.187.187v.827a1.046 1.046 0 0 0-.821 1.02c0 .5.352.919.82 1.021v.827a.187.187 0 0 1-.186.188H.652a.187.187 0 0 1-.187-.188z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.1,
    d: "M3.84 1.291l-.016-.01-.01.016-1.38 2.175-.01.016.015.01.325.206.016.01.01-.016 1.38-2.175.01-.016-.016-.01-.325-.206z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponIcon);
export default __webpack_public_path__ + "static/media/coupon_icon.3dee23de64cdeaff102e05530bd30568.svg";
export { ForwardRef as ReactComponent };